class BundleProductSelector {
    constructor() {
      this.checkboxes = document.querySelectorAll('.bundle-check-input');
      this.mobileQuickAddInput = document.querySelector('.custom-mobile-quickAdd quick-add-product input[name="id"]');
      this.init();
    }
  
    init() {
      // First uncheck all checkboxes
      if (this.checkboxes.length > 0) {
        this.checkboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
        
        // Then click the first checkbox
        this.checkboxes[0].click();
        console.log('Selected Variant ID:', this.checkboxes[0].dataset.variantId);
        // Update mobile quick add input with initial variant
        if (this.mobileQuickAddInput) {
          this.mobileQuickAddInput.value = this.checkboxes[0].dataset.variantId;
        }
      }
  
      // Add event listeners to all checkboxes
      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
      });
    }
  
    handleCheckboxChange(event) {
      const currentCheckbox = event.target;
      const variantId = currentCheckbox.dataset.variantId;
  
      // If the current checkbox is being unchecked, prevent it
      if (!currentCheckbox.checked) {
        currentCheckbox.checked = true;
        return;
      }
  
      // Uncheck all other checkboxes
      this.checkboxes.forEach(checkbox => {
        if (checkbox !== currentCheckbox) {
          checkbox.checked = false;
        }
      });
  
      // Log the selected variant ID
      console.log('Selected Variant ID:', variantId);
  
      // Update mobile quick add input value
      if (this.mobileQuickAddInput) {
        this.mobileQuickAddInput.value = variantId;
      }
      
      // Find and click matching bundle option element
      const bundleOptions = document.querySelectorAll(".bundle-options-list .bundle-option");
      bundleOptions.forEach(option => {
        if (option.dataset.variantId === variantId) {
          console.log('Found matching bundle option, clicking it');
          option.click();
        }
      });
      
      // Close all collapsible elements first
      const allCollapsibleDetails = document.querySelectorAll('.bundle-section-container collapsible-elements details');
      allCollapsibleDetails.forEach(details => {
        details.removeAttribute('open');
        const accordionBody = details.querySelector('.accordion__body.rte');
        if (accordionBody) {
          accordionBody.removeAttribute('style');
        }
      });
      
      // Open the collapsible element nearest to the clicked checkbox
      const parentItem = currentCheckbox.closest('.bundle-product-item');
      if (parentItem) {
        const detailsElement = parentItem.querySelector('collapsible-elements details');
        if (detailsElement) {
          detailsElement.setAttribute('open', 'true');
          
          // Set height: auto on the accordion body
          const accordionBody = detailsElement.querySelector('.accordion__body.rte');
          if (accordionBody) {
            accordionBody.style.height = 'auto';
          }
        }
      }
    }
  }
  
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new BundleProductSelector();
  });

  // Handle section refresh on URL change
  document.addEventListener('shopify:section:load', (event) => {
    // Check if the loaded section contains bundle products
    if (event.target.querySelector('.bundle-check-input')) {
      console.log('Bundle section refreshed, reinitializing...');
      new BundleProductSelector();
    }
  });

  // Additional listener for URL changes
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      console.log('URL changed to', url);
      
      // Find and reinitialize bundle sections
      const bundleSections = document.querySelectorAll('.bundle-section-container');
      if (bundleSections.length > 0) {
        console.log('Found bundle sections after URL change, reinitializing...');
        new BundleProductSelector();
      }
    }
  }).observe(document, {subtree: true, childList: true});